var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useRef, useState } from 'react';
import { Modal } from '../components';
import { DefaultErrorWrapper } from '../components/DefaultErrorWrapper';
var ModalContext = createContext({
    isOpened: false,
    openWith: function () { },
    content: _jsx("div", {}, void 0),
    closeModal: function () { },
    handleError: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
});
export var ModalProvider = function (_a) {
    var children = _a.children, _b = _a.ErrorMessageWrapper, ErrorMessageWrapper = _b === void 0 ? DefaultErrorWrapper : _b;
    var _c = useState(false), isOpened = _c[0], setIsOpened = _c[1];
    var _d = useState(false), triggerModalUpdate = _d[1];
    var ref = useRef(_jsx("div", {}, void 0));
    var onCloseOverrideRef = useRef();
    var openWith = function (content, onClosedOverride) {
        ref.current = content;
        onCloseOverrideRef.current = onClosedOverride;
        if (isOpened) {
            triggerModalUpdate(function (prev) { return !prev; });
        }
        setIsOpened(true);
    };
    var closeModal = function () {
        var callback = onCloseOverrideRef.current;
        onCloseOverrideRef.current = undefined;
        callback === null || callback === void 0 ? void 0 : callback();
        setIsOpened(false);
    };
    function handleError(promiseFn) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, promiseFn()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) {
                            openWith(_jsx(ErrorMessageWrapper, { children: e_1.message }, void 0));
                        }
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(ModalContext.Provider, __assign({ value: {
            isOpened: isOpened,
            openWith: openWith,
            content: ref.current,
            closeModal: closeModal,
            handleError: handleError,
        } }, { children: [_jsx(Modal, {}, void 0), children] }), void 0));
};
export var useModal = function () {
    return useContext(ModalContext);
};
//# sourceMappingURL=useModal.js.map